export default "__VITE_ASSET__DXQlkLo5__"